// Энтрипоинт страницы /coach: CSP режет инлайн-скрипты, поэтому панель CTA
// из макета и обвязка формы едут бандлом, который вьюха подключает сама.
import { initCtaBar } from '../lib/consultCtaBar'
import { initConsultForm } from '../lib/consultForm'

initCtaBar(document)
initConsultForm(document)
